(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.YoutubePublicPresence = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'YouTube public presence data by day',
            channelName: sourceDetails[sources.YOUTUBE].name,
            postName: sourceDetails[sources.YOUTUBE].postName,

            storageDimensions: [
                'companyId',
                'day'
            ],

            availableDimensions: [
                'companySetId',
                'week',
                'month'
            ],

            fields: {
                audience: {
                    name: 'Subscribers',
                    collection: collection.AUDIENCE,
                    dataType: dataType.INTEGER
                },
                page_views: {
                    name: 'Views, Lifetime',
                    collection: collection.VIDEO_VIEWS_DETAILS,
                    dataType: dataType.INTEGER
                },
                lifetime_videos: {
                    name: 'Videos',
                    collection: collection.ACTIVITY,
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod
            ]
        };
    }
})();
